import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { getCoverageArmMetrics } from "./get-coverage-arm-metrics";

export const getLegacyCoverageSplitMetrics = {
  name: "getLegacyCoverageSplitMetrics" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: getCoverageArmMetrics.output,
};
